import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import ButtonDownload from './ButtonDownload'
import { actions } from '../../../store'

const mapStateToProps = state => ({
  rows: state.storage.table.rows
})

const mapDispatchToProps = dispatch => bindActionCreators({
  downloadStorageFile: actions.storage.downloadStorageFile,
  clearDownloadList: actions.storage.clearDownloadList
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ButtonDownload)



// WEBPACK FOOTER //
// ./src/components/Parts/ButtonDownload/index.js